export const reasonOptions = [
  { label: "I'm correcting the address", value: "correction" },
  { label: "I'm updating to a new address", value: "update" },
] as const;
